import { seedsLightTheme } from "../generated/compatibility";

// Runtime values are generated from the DTCG sources in seeds-theme. These
// named exports preserve the historical module contract for internal builders
// and type declarations while the package acts as a compatibility adapter.
export var breakpoints = seedsLightTheme.breakpoints;
export var colors = seedsLightTheme.colors;
export var typography = seedsLightTheme.typography.typography;
export var fontSizes = seedsLightTheme.fontSizes;
export var lineHeights = seedsLightTheme.lineHeights;
export var fontFamily = seedsLightTheme.fontFamily;
export var fontWeights = seedsLightTheme.fontWeights;
export var space = seedsLightTheme.space.space;
export var radii = seedsLightTheme.radii.radii;
export var borders = seedsLightTheme.borders;
export var borderWidths = seedsLightTheme.borderWidths;
export var shadows = seedsLightTheme.shadows;
export var easing = seedsLightTheme.easing;
export var duration = seedsLightTheme.duration;
export default seedsLightTheme;